import React from "react";

const FacebookIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="25"
      viewBox="0 0 13 25"
    >
      <path
        d="M12.9925 11.0257L12.6807 13.5678C12.628 13.9925 12.2738 14.3119 11.8536 14.3119L7.79817 14.3119L7.79817 24.9407C7.37048 24.9799 6.93715 25 6.4991 25C5.51938 25 4.56322 24.9005 3.63908 24.7112L3.63908 14.3119L0.520003 14.3119C0.233625 14.3119 0 14.0738 0 13.7821L0 10.601C0 10.3093 0.233625 10.0712 0.520003 10.0712L3.63908 10.0712L3.63908 5.30051C3.63908 2.37289 5.96685 0 8.83912 0L12.4782 0C12.7646 0 12.9982 0.23815 12.9982 0.52986L12.9982 3.71093C12.9982 4.00264 12.7646 4.24079 12.4782 4.24079L9.87818 4.24079C8.72984 4.24079 7.79911 5.18956 7.79911 6.36119L7.79911 10.0721L12.1664 10.0721C12.6675 10.0721 13.0547 10.5197 12.9935 11.0266L12.9925 11.0257Z"
        fillRule="nonzero"
        transform="matrix(1 0 0 1 0 0)"
        fill="rgb(255, 255, 255)"
      />
    </svg>
  );
};

export default FacebookIcon;
